import { Component, OnDestroy, OnInit } from '@angular/core';
import { ValidatorService } from '../../../services';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ValidationProviderDetails } from '../../../models';
import { Utils } from '../../../utils';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-validators-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css']
})

export class ValidatorsViewComponent implements OnInit, OnDestroy {

    validationProviderDetails: ValidationProviderDetails;
    validatorProvider: any;

    constructor(
        private router: Router,
        private validatorService: ValidatorService,
        private utils: Utils,
        private messageService: MessageService,
        private location: Location) { }

    ngOnInit() {
        this.validatorProvider = JSON.parse(localStorage.getItem("currentValidatorProvider"));
    }

    save(): void {
        let validationProviderDetails: ValidationProviderDetails = new ValidationProviderDetails();
        validationProviderDetails.id = this.validatorProvider.id;
        validationProviderDetails.active = this.validatorProvider.active;
        validationProviderDetails.label = this.validatorProvider.label;
        this.validatorService.saveValidator(validationProviderDetails)
            .subscribe(
                () => {
                    localStorage.removeItem('currentValidatorProvider');
                    this.messageService.add({ severity: 'success', summary: 'Zapisano dane walidatora' });
                    this.router.navigate(['/validators'])
                },
                error => {
                    this.messageService.add({ severity: 'error', summary: 'Nie zapisano danych walidatora', detail: this.utils.handleError(error) });
                }
            );
    }

    cancel(): void {
        this.location.back();
    }

    ngOnDestroy() {
    }
}
